
/**
 * LessonsGridSkeleton component - displays loading skeleton for lessons grid
 * Shows animated placeholder cards while lessons are being fetched
 */
export const LessonsGridSkeleton = () => {
  return (
    <div className="flex flex-col gap-6 max-w-2xl mx-auto px-8">
      {[1, 2, 3].map((i) => (
        <div 
          key={i}
          className="h-48 bg-gray-100 rounded-lg animate-pulse"
        />
      ))}
    </div>
  );
};
